import React, { useState, lazy } from 'react';
import { motion } from 'framer-motion';
import { Star, Check, X, Shield, Mail, ChevronLeft, ChevronRight } from 'lucide-react';
export function App() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const materialImages = [{
    url: 'https://cdn.magicpatterns.com/uploads/n82NxpmQdiqdGCojHQbJtZ/WhatsApp_Image_2026-05-02_at_12.00.50.webp',
    title: 'Tomo 1 · Autopsia de tu Baño',
    subtitle: 'Tabla de compatibilidad de ingredientes — pág. 14'
  }, {
    url: 'https://cdn.magicpatterns.com/uploads/eWgCmGTVYK4QtikZqdZfLg/WhatsApp_Image_2026-05-02_at_12.00.10_(1).webp',
    title: 'Tomo 2 · La Matriz de Activos',
    subtitle: 'Análisis Retinol, Vitamina C y Niacinamida — pág. 31'
  }, {
    url: 'https://cdn.magicpatterns.com/uploads/6LcxfvZnvr9CREmaTvgCqC/WhatsApp_Image_2026-05-02_at_12.02.25.webp',
    title: 'Tomo 3 · Protocolo Reset',
    subtitle: 'Reparación de barrera cutánea semana a semana — pág. 8'
  }, {
    url: 'https://cdn.magicpatterns.com/uploads/bpbXkTybN5PrwBSmKMFrKX/WhatsApp_Image_2026-05-02_at_12.41.31.webp',
    title: 'Tomo 4 · Reconstrucción Inteligente',
    subtitle: 'Orden de reintroducción de activos por tipo de piel — pág. 22'
  }];
  const nextSlide = () => {
    setCurrentSlide(prev => (prev + 1) % materialImages.length);
  };
  const prevSlide = () => {
    setCurrentSlide(prev => (prev - 1 + materialImages.length) % materialImages.length);
  };
  const fadeInUp = {
    initial: {
      opacity: 0,
      y: 20
    },
    whileInView: {
      opacity: 1,
      y: 0
    },
    viewport: {
      once: true
    },
    transition: {
      duration: 0.5
    }
  };
  return <div className="min-w-full bg-white" data-id="element-0">
      {/* Hero Section */}
      <section className="bg-gradient-to-b from-[#F9F5FC] to-white px-4 py-8 md:py-16" data-id="element-1">
        <div className="max-w-4xl mx-auto" data-id="element-2">
          <motion.div {...fadeInUp} className="text-center mb-4" data-id="element-3">
            <span className="inline-block bg-[#5B2D8E] text-white px-4 py-2 rounded-full text-sm md:text-base font-medium" data-id="element-4">
              Para mujeres hartas de gastar en productos que no funcionan
            </span>
          </motion.div>

          <motion.h1 {...fadeInUp} transition={{
          delay: 0.1,
          duration: 0.5
        }} className="text-3xl md:text-5xl lg:text-6xl font-bold text-[#5B2D8E] text-center mb-6 leading-tight" data-id="element-5">
            Tu piel no está mal.
            <br data-id="element-6" />
            Está mal informada.
          </motion.h1>

          <motion.div {...fadeInUp} transition={{
          delay: 0.2,
          duration: 0.5
        }} className="mb-8 flex justify-center" data-id="element-7">
            <img src="https://cdn.magicpatterns.com/uploads/o38TUXi4BTDKSo3BT3uckj/mockup_webp_sin_fondo.webp" alt="El Auditor de Skincare" className="w-full max-w-md md:max-w-lg" width="800" height="800" fetchpriority="high" loading="eager" decoding="async" data-id="element-8" />
          </motion.div>

          <motion.p {...fadeInUp} transition={{
          delay: 0.3,
          duration: 0.5
        }} className="text-lg md:text-xl text-[#4A4A4A] text-center mb-6 px-4" data-id="element-9">
            <span className="font-bold text-[#5B2D8E]" data-id="element-10">
              EL AUDITOR DE SKINCARE™
            </span>{' '}
            — El sistema científico en 5 tomos que audita tu rutina, elimina lo
            que no funciona y transforma tu piel en 6 semanas. Sin confusión.
            Sin dinero tirado.
          </motion.p>

          <motion.div {...fadeInUp} transition={{
          delay: 0.4,
          duration: 0.5
        }} className="flex justify-center items-center gap-2 mb-4" data-id="element-11">
            <div className="flex" data-id="element-12">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-[#C9A84C] text-[#C9A84C]" data-id="element-13" />)}
            </div>
            <span className="text-[#4A4A4A] font-medium" data-id="element-14">
              4.8/5 · +340 reseñas verificadas
            </span>
          </motion.div>

          <motion.p {...fadeInUp} transition={{
          delay: 0.5,
          duration: 0.5
        }} className="text-center text-[#5B2D8E] font-semibold mb-6" data-id="element-15">
            🔥 28 mujeres eligieron este sistema hoy
          </motion.p>

          <motion.div {...fadeInUp} transition={{
          delay: 0.6,
          duration: 0.5
        }} className="text-center" data-id="element-16">
            <a href="#pricing" className="inline-block bg-[#C9A84C] hover:bg-[#b89840] text-white font-bold text-lg md:text-xl px-8 py-4 rounded-lg transition-colors shadow-lg" data-id="element-17">
              🚀 SÍ, QUIERO EL AUDITOR DE SKINCARE™
            </a>
            <p className="mt-4 text-sm text-[#4A4A4A]" data-id="element-18">
              ⚡ Acceso inmediato · 🛡️ Garantía 14 días · 💳 Pago único
            </p>
          </motion.div>
        </div>
      </section>

      {/* Stats Bar */}
      <section className="bg-[#5B2D8E] text-white py-6 md:py-8" data-id="element-19">
        <div className="max-w-6xl mx-auto px-4" data-id="element-20">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8 text-center" data-id="element-21">
            <motion.div {...fadeInUp} data-id="element-22">
              <div className="text-2xl md:text-3xl font-bold mb-1" data-id="element-23">+2.800</div>
              <div className="text-sm md:text-base opacity-90" data-id="element-24">
                Mujeres activas
              </div>
            </motion.div>
            <motion.div {...fadeInUp} transition={{
            delay: 0.1,
            duration: 0.5
          }} data-id="element-25">
              <div className="text-2xl md:text-3xl font-bold mb-1" data-id="element-26">94%</div>
              <div className="text-sm md:text-base opacity-90" data-id="element-27">
                Tasa de satisfacción
              </div>
            </motion.div>
            <motion.div {...fadeInUp} transition={{
            delay: 0.2,
            duration: 0.5
          }} data-id="element-28">
              <div className="text-2xl md:text-3xl font-bold mb-1" data-id="element-29">
                6 semanas
              </div>
              <div className="text-sm md:text-base opacity-90" data-id="element-30">
                Resultado visible
              </div>
            </motion.div>
            <motion.div {...fadeInUp} transition={{
            delay: 0.3,
            duration: 0.5
          }} data-id="element-31">
              <div className="text-2xl md:text-3xl font-bold mb-1" data-id="element-32">−80%</div>
              <div className="text-sm md:text-base opacity-90" data-id="element-33">
                Gasto eliminado
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Transformation Section */}
      <section className="py-12 md:py-20 px-4 bg-white" data-id="element-34">
        <div className="max-w-6xl mx-auto" data-id="element-35">
          <motion.h2 {...fadeInUp} className="text-3xl md:text-4xl font-bold text-[#5B2D8E] text-center mb-3" data-id="element-36">
            ⚡ La transformación
          </motion.h2>
          <motion.p {...fadeInUp} className="text-lg md:text-xl text-[#4A4A4A] text-center mb-12" data-id="element-37">
            De una piel frustrada a una piel que por fin responde.
          </motion.p>

          <div className="grid md:grid-cols-2 gap-6 mb-8" data-id="element-38">
            {[{
            before: 'Gastas 80€ al mes en productos que no funcionan juntos.',
            after: 'Sabes exactamente qué conservar y qué tirar. Tu rutina cuesta la mitad.'
          }, {
            before: 'Pruebas todo lo que ves en TikTok sin saber si es para ti.',
            after: 'Tomas decisiones con criterio. Nunca más compras por impulso.'
          }, {
            before: 'Llevas meses usando activos sin ver cambios reales.',
            after: 'Protocolo personalizado. Resultados visibles en 6 semanas.'
          }, {
            before: 'Tu piel reacciona mal, se irrita o se seca sin razón aparente.',
            after: 'Entiendes exactamente qué le pasa y cómo solucionarlo.'
          }].map((item, index) => <motion.div key={index} {...fadeInUp} transition={{
            delay: index * 0.1,
            duration: 0.5
          }} className="bg-[#F9F5FC] rounded-lg p-6 border-2 border-[#E8D5F5]" data-id="element-39">
                <div className="mb-4" data-id="element-40">
                  <div className="flex items-start gap-2 mb-2" data-id="element-41">
                    <X className="w-5 h-5 text-red-500 flex-shrink-0 mt-1" data-id="element-42" />
                    <p className="text-[#4A4A4A]" data-id="element-43">
                      <span className="font-semibold" data-id="element-44">Antes:</span>{' '}
                      {item.before}
                    </p>
                  </div>
                </div>
                <div data-id="element-45">
                  <div className="flex items-start gap-2" data-id="element-46">
                    <Check className="w-5 h-5 text-green-500 flex-shrink-0 mt-1" data-id="element-47" />
                    <p className="text-[#4A4A4A]" data-id="element-48">
                      <span className="font-semibold" data-id="element-49">Ahora:</span> {item.after}
                    </p>
                  </div>
                </div>
              </motion.div>)}
          </div>

          <motion.div {...fadeInUp} className="text-center" data-id="element-50">
            <a href="#pricing" className="inline-block bg-[#C9A84C] hover:bg-[#b89840] text-white font-bold text-lg px-8 py-4 rounded-lg transition-colors" data-id="element-51">
              🚀 Quiero esta transformación
            </a>
          </motion.div>
        </div>
      </section>

      {/* This is for you if */}
      <section className="py-12 md:py-20 px-4 bg-[#F9F5FC]" data-id="element-52">
        <div className="max-w-4xl mx-auto" data-id="element-53">
          <motion.h2 {...fadeInUp} className="text-3xl md:text-4xl font-bold text-[#5B2D8E] text-center mb-3" data-id="element-54">
            👀 Esto es para ti si…
          </motion.h2>
          <motion.p {...fadeInUp} className="text-lg md:text-xl text-[#4A4A4A] text-center mb-12" data-id="element-55">
            ¿Te suena alguna de estas escenas?
          </motion.p>

          <div className="space-y-6 mb-8" data-id="element-56">
            {[{
            emoji: '😩',
            title: 'Tienes el baño lleno de productos y tu piel sigue igual.',
            desc: 'Gastas, acumulas y pruebas. Pero nada funciona de verdad porque nunca supiste si eran los correctos para tu piel.'
          }, {
            emoji: '📉',
            title: 'Usas activos fuertes pero no ves resultados.',
            desc: 'Retinol, vitamina C, niacinamida… los tienes todos. Pero los estás usando mal y se anulan entre sí.'
          }, {
            emoji: '🔄',
            title: 'Tu piel empeora cada vez que introduces algo nuevo.',
            desc: 'Irritación, brotes, sensibilidad. Tu piel no aguanta nada y no sabes por qué.'
          }, {
            emoji: '👥',
            title: 'No sabes en qué orden usar tus productos.',
            desc: 'Por la mañana, por la noche, con o sin protector, antes o después del sérum. Es un caos constante.'
          }, {
            emoji: '😨',
            title: 'Las marcas y TikTok te confunden a propósito.',
            desc: 'Cada semana hay un nuevo ingrediente milagroso. No sabes qué creer ni en quién fiarte.'
          }, {
            emoji: '💼',
            title: 'Quieres resultados de clínica sin pagar precios de clínica.',
            desc: 'Sabes que existe una forma de tener una piel increíble en casa. Solo necesitas el sistema correcto.'
          }].map((item, index) => <motion.div key={index} {...fadeInUp} transition={{
            delay: index * 0.1,
            duration: 0.5
          }} className="bg-white rounded-lg p-6 shadow-sm" data-id="element-57">
                <div className="flex gap-4" data-id="element-58">
                  <div className="text-3xl flex-shrink-0" data-id="element-59">{item.emoji}</div>
                  <div data-id="element-60">
                    <div className="flex items-start gap-2 mb-2" data-id="element-61">
                      <span className="bg-[#5B2D8E] text-white rounded-full w-8 h-8 flex items-center justify-center flex-shrink-0 font-bold text-sm" data-id="element-62">
                        {String(index + 1).padStart(2, '0')}
                      </span>
                      <h3 className="font-bold text-[#5B2D8E] text-lg" data-id="element-63">
                        {item.title}
                      </h3>
                    </div>
                    <p className="text-[#4A4A4A] ml-10" data-id="element-64">{item.desc}</p>
                  </div>
                </div>
              </motion.div>)}
          </div>

          <motion.div {...fadeInUp} className="bg-[#5B2D8E] text-white rounded-lg p-6 text-center mb-6" data-id="element-65">
            <p className="text-lg md:text-xl font-semibold mb-4" data-id="element-66">
              ✋ ¿Te reconociste en 2 o más? Este sistema fue hecho para ti.
            </p>
            <a href="#pricing" className="inline-block bg-[#C9A84C] hover:bg-[#b89840] text-white font-bold text-lg px-8 py-4 rounded-lg transition-colors" data-id="element-67">
              Quiero el sistema completo
            </a>
          </motion.div>
        </div>
      </section>

      {/* What You Receive */}
      <section className="py-12 md:py-20 px-4 bg-white" data-id="element-68">
        <div className="max-w-6xl mx-auto" data-id="element-69">
          <motion.h2 {...fadeInUp} className="text-3xl md:text-4xl font-bold text-[#5B2D8E] text-center mb-3" data-id="element-70">
            🎁 Lo que recibes hoy
          </motion.h2>
          <motion.p {...fadeInUp} className="text-lg md:text-xl text-[#4A4A4A] text-center mb-8" data-id="element-71">
            Todo lo que necesita tu piel. En un solo sistema.
          </motion.p>

          <motion.div {...fadeInUp} className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-12 text-center" data-id="element-72">
            <div data-id="element-73">
              <div className="text-2xl md:text-3xl font-bold text-[#5B2D8E] mb-1" data-id="element-74">
                200+
              </div>
              <div className="text-sm text-[#4A4A4A]" data-id="element-75">Activos analizados</div>
            </div>
            <div data-id="element-76">
              <div className="text-2xl md:text-3xl font-bold text-[#5B2D8E] mb-1" data-id="element-77">
                5
              </div>
              <div className="text-sm text-[#4A4A4A]" data-id="element-78">Tomos completos</div>
            </div>
            <div data-id="element-79">
              <div className="text-2xl md:text-3xl font-bold text-[#5B2D8E] mb-1" data-id="element-80">
                6 semanas
              </div>
              <div className="text-sm text-[#4A4A4A]" data-id="element-81">al resultado</div>
            </div>
            <div data-id="element-82">
              <div className="text-2xl md:text-3xl font-bold text-[#5B2D8E] mb-1" data-id="element-83">
                100%
              </div>
              <div className="text-sm text-[#4A4A4A]" data-id="element-84">Personalizable</div>
            </div>
          </motion.div>

          <motion.h3 {...fadeInUp} className="text-2xl md:text-3xl font-bold text-[#5B2D8E] mb-2" data-id="element-85">
            Los 5 Tomos — Valor 67€
          </motion.h3>

          <div className="space-y-4 mb-12" data-id="element-86">
            {[{
            icon: '📚',
            title: 'Tomo 1 · Autopsia de tu Baño',
            desc: 'Audita cada producto que tienes ahora mismo. Descubre qué guardar y qué tirar.'
          }, {
            icon: '📚',
            title: 'Tomo 2 · La Matriz de Activos',
            desc: 'Qué hace cada ingrediente, si lo necesitas tú y cómo combinarlo correctamente.'
          }, {
            icon: '📚',
            title: 'Tomo 3 · El Protocolo Reset',
            desc: 'Cómo reparar tu barrera cutánea desde cero antes de introducir cualquier activo.'
          }, {
            icon: '📚',
            title: 'Tomo 4 · Reconstrucción Inteligente',
            desc: 'Reintroduce activos sin destruir lo que sanaste. Orden, dosis y frecuencia exactos.'
          }, {
            icon: '📚',
            title: 'Tomo 5 · Tu Piel Para Siempre',
            desc: 'El sistema de mantenimiento de por vida. Cómo adaptar tu rutina a cada temporada.'
          }].map((item, index) => <motion.div key={index} {...fadeInUp} transition={{
            delay: index * 0.1,
            duration: 0.5
          }} className="bg-[#E8D5F5] rounded-lg p-6" data-id="element-87">
                <div className="flex gap-4" data-id="element-88">
                  <div className="text-3xl flex-shrink-0" data-id="element-89">{item.icon}</div>
                  <div data-id="element-90">
                    <h4 className="font-bold text-[#5B2D8E] text-lg mb-2" data-id="element-91">
                      {item.title}
                    </h4>
                    <p className="text-[#4A4A4A]" data-id="element-92">{item.desc}</p>
                  </div>
                </div>
              </motion.div>)}
          </div>

          <motion.h3 {...fadeInUp} className="text-2xl md:text-3xl font-bold text-[#5B2D8E] mb-6" data-id="element-93">
            Los 3 Bonos Estratégicos
          </motion.h3>

          <div className="space-y-4 mb-8" data-id="element-94">
            {[{
            icon: '🆘',
            title: 'Bono 1 · Rutas de Emergencia S.O.S',
            desc: 'Qué hacer cuando tu piel entra en crisis ahora mismo.',
            value: '15€'
          }, {
            icon: '✨',
            title: 'Bono 2 · El Brillo Interno',
            desc: 'Protocolo de nutrición e hidratación que potencia todo lo demás desde dentro.',
            value: '12€'
          }, {
            icon: '💰',
            title: 'Bono 3 · El Planificador de Ahorro',
            desc: 'Calcula exactamente cuánto dinero vas a ahorrar este año con tu nueva rutina.',
            value: '12€'
          }].map((item, index) => <motion.div key={index} {...fadeInUp} transition={{
            delay: index * 0.1,
            duration: 0.5
          }} className="bg-[#F9F5FC] rounded-lg p-6 border-2 border-[#C9A84C]" data-id="element-95">
                <div className="flex gap-4" data-id="element-96">
                  <div className="text-3xl flex-shrink-0" data-id="element-97">{item.icon}</div>
                  <div className="flex-1" data-id="element-98">
                    <h4 className="font-bold text-[#5B2D8E] text-lg mb-2" data-id="element-99">
                      {item.title}
                    </h4>
                    <p className="text-[#4A4A4A] mb-2" data-id="element-100">{item.desc}</p>
                    <p className="text-green-600 font-semibold" data-id="element-101">
                      ✅ GRATIS — Valor {item.value}
                    </p>
                  </div>
                </div>
              </motion.div>)}
          </div>

          <motion.div {...fadeInUp} className="text-center" data-id="element-102">
            <a href="#pricing" className="inline-block bg-[#C9A84C] hover:bg-[#b89840] text-white font-bold text-lg px-8 py-4 rounded-lg transition-colors" data-id="element-103">
              🚀 Quiero el sistema completo
            </a>
          </motion.div>
        </div>
      </section>

      {/* Material Preview */}
      <section className="py-12 md:py-20 px-4 bg-[#F9F5FC]" data-id="element-104">
        <div className="max-w-7xl mx-auto" data-id="element-105">
          <motion.div {...fadeInUp} className="text-center mb-4" data-id="element-106">
            <span className="inline-block bg-white text-[#5B2D8E] px-6 py-2 rounded-full text-sm font-semibold border-2 border-[#5B2D8E]" data-id="element-107">
              📸 IMÁGENES REALES DEL MATERIAL — SIN SIMULACIONES
            </span>
          </motion.div>

          <motion.h2 {...fadeInUp} className="text-3xl md:text-4xl font-bold text-[#5B2D8E] text-center mb-12" data-id="element-108">
            Mira el material por dentro
          </motion.h2>

          <div className="relative" data-id="element-109">
            {/* Carousel Container */}
            <div className="flex items-center justify-center gap-4 md:gap-8" data-id="element-110">
              {/* Previous Button */}
              <button onClick={prevSlide} className="flex-shrink-0 w-12 h-12 md:w-16 md:h-16 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-[#F9F5FC] transition-colors z-10" aria-label="Imagen anterior" data-id="element-111">
                <ChevronLeft className="w-6 h-6 md:w-8 md:h-8 text-[#5B2D8E]" data-id="element-112" />
              </button>

              {/* Main Image Display */}
              <motion.div key={currentSlide} initial={{
              opacity: 0,
              scale: 0.95
            }} animate={{
              opacity: 1,
              scale: 1
            }} transition={{
              duration: 0.3
            }} className="flex-1 max-w-2xl" data-id="element-113">
                <div className="bg-white rounded-2xl shadow-2xl overflow-hidden border-4 border-[#E8D5F5]" data-id="element-114">
                  <img src={materialImages[currentSlide].url} alt={materialImages[currentSlide].title} className="w-full h-auto" width="600" height="800" loading="lazy" decoding="async" data-id="element-115" />
                </div>
                <div className="mt-6 text-center" data-id="element-116">
                  <h4 className="font-bold text-[#5B2D8E] text-lg md:text-xl mb-2" data-id="element-117">
                    {''}
                  </h4>
                  <p className="text-sm md:text-base text-[#4A4A4A]" data-id="element-118">{''}</p>
                </div>
              </motion.div>

              {/* Next Button */}
              <button onClick={nextSlide} className="flex-shrink-0 w-12 h-12 md:w-16 md:h-16 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-[#F9F5FC] transition-colors z-10" aria-label="Siguiente imagen" data-id="element-119">
                <ChevronRight className="w-6 h-6 md:w-8 md:h-8 text-[#5B2D8E]" data-id="element-120" />
              </button>
            </div>

            {/* Page Indicator */}
            <div className="text-center mt-8" data-id="element-121">
              <span className="text-2xl font-bold text-[#5B2D8E]" data-id="element-122">
                {currentSlide + 1} / {materialImages.length}
              </span>
            </div>

            {/* Dots Indicator */}
            <div className="flex justify-center gap-2 mt-4" data-id="element-123">
              {materialImages.map((_, index) => <button key={index} onClick={() => setCurrentSlide(index)} className={`h-2 rounded-full transition-all ${index === currentSlide ? 'w-8 bg-[#5B2D8E]' : 'w-2 bg-[#E8D5F5] hover:bg-[#C9A84C]'}`} aria-label={`Ir a imagen ${index + 1}`} data-id="element-124" />)}
            </div>
          </div>

          <motion.p {...fadeInUp} className="text-center text-[#4A4A4A] italic mt-12" data-id="element-125">
            💡 Estas son páginas reales del sistema. Lo que ves es exactamente
            lo que recibes.
          </motion.p>
        </div>
      </section>

      {/* Pricing */}
      <section id="pricing" className="py-12 md:py-20 px-4 bg-white" data-id="element-126">
        <div className="max-w-6xl mx-auto" data-id="element-127">
          <motion.h2 {...fadeInUp} className="text-3xl md:text-4xl font-bold text-[#5B2D8E] text-center mb-3" data-id="element-128">
            💰 Elige tu nivel de transformación
          </motion.h2>
          <motion.p {...fadeInUp} className="text-lg md:text-xl text-[#4A4A4A] text-center mb-12" data-id="element-129">
            Dos opciones. Una decisión obvia.
          </motion.p>

          <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-130">
            {/* Premium Tier */}
            <motion.div {...fadeInUp} className="bg-gradient-to-br from-[#5B2D8E] to-[#7B4DAE] rounded-lg p-8 text-white relative shadow-xl border-4 border-[#C9A84C]" data-id="element-131">
              <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-[#C9A84C] text-white px-6 py-2 rounded-full font-bold text-sm whitespace-nowrap" data-id="element-132">
                🏆 MÁS POPULAR — LA OPCIÓN MÁS ELEGIDA
              </div>

              <div className="mt-4 mb-6" data-id="element-133">
                <h3 className="text-2xl md:text-3xl font-bold mb-2" data-id="element-134">
                  PIEL SIN FILTROS™
                </h3>
                <p className="text-sm opacity-90" data-id="element-135">
                  Sistema de Alta Potencia · Para las que van en serio
                </p>
              </div>

              <div className="mb-6" data-id="element-136">
                <div className="text-lg line-through opacity-75 mb-1" data-id="element-137">212€</div>
                <div className="text-5xl font-bold mb-2" data-id="element-138">19,99€</div>
                <div className="text-sm opacity-90" data-id="element-139">
                  Pago único · Sin suscripción
                </div>
              </div>

              <div className="bg-[#F0D080] text-[#5B2D8E] rounded-lg p-4 mb-6" data-id="element-140">
                <p className="text-sm font-semibold" data-id="element-141">
                  💡 Por solo 6€ más que la base recibes el doble de contenido y
                  resultados más rápidos
                </p>
              </div>

              <div className="space-y-3 mb-8" data-id="element-142">
                {[{
                text: 'Los 5 Tomos del Sistema Auditor',
                value: '67€'
              }, {
                text: '3 Bonos Estratégicos',
                value: '39€'
              }, {
                text: '⚡ Rutinas de Alta Potencia',
                value: '27€'
              }, {
                text: '⚡ Arsenal de Dispositivos',
                value: '19€'
              }, {
                text: '⚡ Resultados de Clínica en Casa',
                value: '19€'
              }, {
                text: '⚡ Protocolo Anti-Edad Acelerado',
                value: '24€'
              }, {
                text: '⚡ Plan de 90 Días Guiado',
                value: '17€'
              }].map((item, index) => <div key={index} className="flex items-start gap-2" data-id="element-143">
                    <Check className="w-5 h-5 flex-shrink-0 mt-0.5" data-id="element-144" />
                    <span className="flex-1" data-id="element-145">{item.text}</span>
                    <span className="text-sm opacity-75" data-id="element-146">{item.value}</span>
                  </div>)}
              </div>

              <a href="#" className="block w-full bg-[#C9A84C] hover:bg-[#b89840] text-white font-bold text-center py-4 rounded-lg transition-colors mb-3" data-id="element-147">
                🚀 SÍ, QUIERO PIEL SIN FILTROS™ — 19,99€
              </a>
              <p className="text-center text-sm opacity-90" data-id="element-148">
                💳 Pago único · ⚡ Acceso inmediato · 🛡️ Garantía 14 días
              </p>
            </motion.div>

            {/* Base Tier */}
            <motion.div {...fadeInUp} transition={{
            delay: 0.1,
            duration: 0.5
          }} className="bg-[#F9F5FC] rounded-lg p-8 border-2 border-[#E8D5F5]" data-id="element-149">
              <div className="mb-6" data-id="element-150">
                <h3 className="text-2xl md:text-3xl font-bold text-[#5B2D8E] mb-2" data-id="element-151">
                  EL AUDITOR™
                </h3>
                <p className="text-sm text-[#4A4A4A]" data-id="element-152">
                  Sistema Científico Completo · La base perfecta
                </p>
              </div>

              <div className="mb-6" data-id="element-153">
                <div className="text-lg line-through text-[#4A4A4A] mb-1" data-id="element-154">
                  106€
                </div>
                <div className="text-5xl font-bold text-[#5B2D8E] mb-2" data-id="element-155">
                  13,99€
                </div>
                <div className="text-sm text-[#4A4A4A]" data-id="element-156">
                  Pago único · Sin suscripción
                </div>
              </div>

              <div className="space-y-3 mb-8" data-id="element-157">
                {[{
                text: 'Los 5 Tomos del Sistema Auditor',
                value: '67€',
                included: true
              }, {
                text: '3 Bonos Estratégicos',
                value: '39€',
                included: true
              }, {
                text: 'Rutinas de Alta Potencia',
                included: false
              }, {
                text: 'Arsenal de Dispositivos',
                included: false
              }, {
                text: 'Resultados de Clínica en Casa',
                included: false
              }, {
                text: 'Protocolo Anti-Edad Acelerado',
                included: false
              }, {
                text: 'Plan de 90 Días Guiado',
                included: false
              }].map((item, index) => <div key={index} className="flex items-start gap-2" data-id="element-158">
                    {item.included ? <Check className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-159" /> : <X className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" data-id="element-160" />}
                    <span className={`flex-1 ${!item.included ? 'opacity-50' : ''}`} data-id="element-161">
                      {item.text}
                    </span>
                    {item.value && <span className="text-sm text-[#4A4A4A]" data-id="element-162">
                        {item.value}
                      </span>}
                  </div>)}
              </div>

              <a href="#" className="block w-full bg-[#5B2D8E] hover:bg-[#4a2570] text-white font-bold text-center py-4 rounded-lg transition-colors mb-3" data-id="element-163">
                Empezar con la base — 13,99€
              </a>
              <p className="text-center text-sm text-[#4A4A4A]" data-id="element-164">
                💳 Pago único · ⚡ Acceso inmediato · 🛡️ Garantía 14 días
              </p>
            </motion.div>
          </div>

          {/* Comparison Table */}
          <motion.div {...fadeInUp} className="overflow-x-auto mb-8" data-id="element-165">
            <div className="text-center text-sm text-[#4A4A4A] mb-4" data-id="element-166">
              ← Scroll to see full table →
            </div>
            <table className="w-full bg-white rounded-lg overflow-hidden shadow-md min-w-[600px]" data-id="element-167">
              <thead className="bg-[#5B2D8E] text-white" data-id="element-168">
                <tr data-id="element-169">
                  <th className="p-4 text-left" data-id="element-170">Contenido</th>
                  <th className="p-4 text-center" data-id="element-171">
                    Auditor Base
                    <br data-id="element-172" />
                    13,99€
                  </th>
                  <th className="p-4 text-center bg-[#C9A84C]" data-id="element-173">
                    Piel Sin Filtros™
                    <br data-id="element-174" />
                    19,99€
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-175">
                {[{
                name: '5 Tomos del Sistema',
                base: true,
                premium: true
              }, {
                name: '3 Bonos Estratégicos',
                base: true,
                premium: true
              }, {
                name: 'Rutinas de Alta Potencia',
                base: false,
                premium: true
              }, {
                name: 'Arsenal de Dispositivos',
                base: false,
                premium: true
              }, {
                name: 'Resultados de Clínica en Casa',
                base: false,
                premium: true
              }, {
                name: 'Protocolo Anti-Edad Acelerado',
                base: false,
                premium: true
              }, {
                name: 'Plan de 90 Días Guiado',
                base: false,
                premium: true
              }].map((row, index) => <tr key={index} className={index % 2 === 0 ? 'bg-[#F9F5FC]' : 'bg-white'} data-id="element-176">
                    <td className="p-4 font-medium text-[#4A4A4A]" data-id="element-177">
                      {row.name}
                    </td>
                    <td className="p-4 text-center" data-id="element-178">
                      {row.base ? <Check className="w-6 h-6 text-green-600 mx-auto" data-id="element-179" /> : <X className="w-6 h-6 text-red-500 mx-auto" data-id="element-180" />}
                    </td>
                    <td className="p-4 text-center" data-id="element-181">
                      {row.premium ? <Check className="w-6 h-6 text-green-600 mx-auto" data-id="element-182" /> : <X className="w-6 h-6 text-red-500 mx-auto" data-id="element-183" />}
                    </td>
                  </tr>)}
                <tr className="bg-[#5B2D8E] text-white font-bold" data-id="element-184">
                  <td className="p-4" data-id="element-185">Precio</td>
                  <td className="p-4 text-center text-xl" data-id="element-186">13,99€</td>
                  <td className="p-4 text-center text-xl bg-[#C9A84C]" data-id="element-187">
                    19,99€
                  </td>
                </tr>
              </tbody>
            </table>
          </motion.div>

          <motion.div {...fadeInUp} className="text-center space-y-4" data-id="element-188">
            <p className="text-[#4A4A4A]" data-id="element-189">
              🧠 El 78% de nuestras clientas eligen PIEL SIN FILTROS™. La
              diferencia son 6€. El resultado es el doble.
            </p>
            <p className="text-[#5B2D8E] font-semibold" data-id="element-190">
              ⏰ Precio de lanzamiento — sube pronto
            </p>
          </motion.div>
        </div>
      </section>

      {/* Guarantee */}
      <section className="py-12 md:py-20 px-4 bg-[#F9F5FC]" data-id="element-191">
        <div className="max-w-4xl mx-auto" data-id="element-192">
          <motion.div {...fadeInUp} className="text-center mb-8" data-id="element-193">
            <Shield className="w-16 h-16 text-[#5B2D8E] mx-auto mb-4" data-id="element-194" />
            <h2 className="text-3xl md:text-4xl font-bold text-[#5B2D8E] mb-3" data-id="element-195">
              🛡️ Garantía total 14 días
            </h2>
            <p className="text-lg md:text-xl text-[#4A4A4A]" data-id="element-196">
              Si no transforma tu forma de ver tu piel, te devolvemos el 100%.
            </p>
          </motion.div>

          <motion.div {...fadeInUp} className="bg-white rounded-lg p-8 mb-8" data-id="element-197">
            <p className="text-[#4A4A4A] mb-6 text-center" data-id="element-198">
              Descarga los 5 tomos. Lee el sistema completo. Aplica el
              protocolo. Si en 14 días no sientes que EL AUDITOR DE SKINCARE™
              es exactamente lo que necesitabas, te devolvemos cada euro.
            </p>

            <div className="grid md:grid-cols-3 gap-6 mb-6" data-id="element-199">
              <div className="text-center" data-id="element-200">
                <div className="text-3xl mb-2" data-id="element-201">🙅‍♀️</div>
                <h4 className="font-bold text-[#5B2D8E] mb-1" data-id="element-202">Sin preguntas</h4>
                <p className="text-sm text-[#4A4A4A]" data-id="element-203">
                  No pedimos explicaciones
                </p>
              </div>
              <div className="text-center" data-id="element-204">
                <div className="text-3xl mb-2" data-id="element-205">📧</div>
                <h4 className="font-bold text-[#5B2D8E] mb-1" data-id="element-206">
                  Sin formularios
                </h4>
                <p className="text-sm text-[#4A4A4A]" data-id="element-207">Solo un email y listo</p>
              </div>
              <div className="text-center" data-id="element-208">
                <div className="text-3xl mb-2" data-id="element-209">⚡</div>
                <h4 className="font-bold text-[#5B2D8E] mb-1" data-id="element-210">Sin drama</h4>
                <p className="text-sm text-[#4A4A4A]" data-id="element-211">Devolución en 48h</p>
              </div>
            </div>

            <p className="text-center text-sm text-[#4A4A4A] italic" data-id="element-212">
              Más de 2.800 mujeres ya lo usan. Tasa de devolución menor al 2%.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-12 md:py-20 px-4 bg-white" data-id="element-213">
        <div className="max-w-6xl mx-auto" data-id="element-214">
          <motion.h2 {...fadeInUp} className="text-3xl md:text-4xl font-bold text-[#5B2D8E] text-center mb-3" data-id="element-215">
            ⭐ Testimonios reales
          </motion.h2>
          <motion.p {...fadeInUp} className="text-lg text-[#4A4A4A] text-center mb-2" data-id="element-216">
            Mujeres de toda España ya transformaron su piel.
          </motion.p>
          <motion.div {...fadeInUp} className="flex justify-center items-center gap-2 mb-12" data-id="element-217">
            <div className="flex" data-id="element-218">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-[#C9A84C] text-[#C9A84C]" data-id="element-219" />)}
            </div>
            <span className="text-[#4A4A4A] font-medium" data-id="element-220">
              4.8/5 · +340 reseñas verificadas
            </span>
          </motion.div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-221">
            {[{
            rating: 5,
            text: 'Me descargué el Tomo 1 un domingo y en dos horas audité todo mi baño. Tiré 6 productos que se estaban anulando entre sí. Nunca lo hubiera descubierto sola.',
            name: 'Laura Martínez',
            title: 'Diseñadora Gráfica · Madrid'
          }, {
            rating: 5,
            text: 'Llevaba un año usando retinol mal. El Tomo 2 me explicó en 20 minutos lo que ninguna marca me había dicho nunca. Mi piel cambió en 3 semanas.',
            name: 'Sara Romero',
            title: 'Profesora · Barcelona'
          }, {
            rating: 5,
            text: 'El Protocolo Reset del Tomo 3 me salvó la piel. Tenía la barrera destrozada y no lo sabía. En 6 semanas mi piel estaba irreconocible.',
            name: 'Alba Rodríguez',
            title: 'Estudiante de Medicina · Sevilla'
          }, {
            rating: 5,
            text: 'El Planificador de Ahorro me demostró que tiraba 74€ al mes en productos incorrectos. El sistema se pagó solo el primer día.',
            name: 'Marta Fernández',
            title: 'Fisioterapeuta · Bilbao'
          }, {
            rating: 5,
            text: 'Las Rutas S.O.S las uso constantemente. Tuve un brote fuerte y en 4 días estaba controlado siguiendo exactamente el protocolo.',
            name: 'Nuria López',
            title: 'Abogada · Zaragoza'
          }, {
            rating: 5,
            text: 'Pensé que era otro PDF genérico. La tabla de compatibilidad de activos es brutal. Por fin entiendo por qué mi piel se irritaba siempre.',
            name: 'Carmen García',
            title: 'Enfermera · Valencia'
          }].map((testimonial, index) => <motion.div key={index} {...fadeInUp} transition={{
            delay: index * 0.1,
            duration: 0.5
          }} className="bg-[#F9F5FC] rounded-lg p-6" data-id="element-222">
                <div className="flex mb-3" data-id="element-223">
                  {[...Array(testimonial.rating)].map((_, i) => <Star key={i} className="w-4 h-4 fill-[#C9A84C] text-[#C9A84C]" data-id="element-224" />)}
                </div>
                <p className="text-[#4A4A4A] mb-4 italic" data-id="element-225">
                  "{testimonial.text}"
                </p>
                <div data-id="element-226">
                  <p className="font-bold text-[#5B2D8E]" data-id="element-227">
                    🇪🇸 {testimonial.name}
                  </p>
                  <p className="text-sm text-[#4A4A4A]" data-id="element-228">{testimonial.title}</p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* About */}
      <section className="py-12 md:py-20 px-4 bg-[#F9F5FC]" data-id="element-229">
        <div className="max-w-4xl mx-auto" data-id="element-230">
          <motion.h2 {...fadeInUp} className="text-3xl md:text-4xl font-bold text-[#5B2D8E] text-center mb-8" data-id="element-231">
            🧴 Acerca del Equipo Auditor de Skincare™
          </motion.h2>

          <motion.div {...fadeInUp} className="bg-white rounded-lg p-8 text-center" data-id="element-232">
            <p className="text-lg text-[#4A4A4A] mb-4 italic" data-id="element-233">
              "Creamos este sistema porque el mercado de la cosmética está lleno
              de ruido, promesas vacías y marketing agresivo. Tu piel no
              necesita más productos. Necesita la verdad. EL AUDITOR nació para
              dártela."
            </p>
            <p className="font-bold text-[#5B2D8E]" data-id="element-234">
              — Equipo Auditor de Skincare™
            </p>
          </motion.div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-12 md:py-20 px-4 bg-white" data-id="element-235">
        <div className="max-w-4xl mx-auto" data-id="element-236">
          <motion.h2 {...fadeInUp} className="text-3xl md:text-4xl font-bold text-[#5B2D8E] text-center mb-12" data-id="element-237">
            ❓ Resolvemos tus dudas
          </motion.h2>

          <div className="space-y-6" data-id="element-238">
            {[{
            q: '¿Cómo recibo el material?',
            a: 'Inmediatamente después del pago recibes un email con el enlace de descarga. Acceso instantáneo, sin esperas.'
          }, {
            q: '¿Es seguro pagar?',
            a: 'Sí. El pago se procesa a través de Shopify con encriptación SSL. Tus datos están 100% protegidos.'
          }, {
            q: '¿Funciona para todo tipo de piel?',
            a: 'Sí. El sistema incluye protocolos específicos para piel grasa, seca, mixta, sensible y con problemas como acné o manchas.'
          }, {
            q: '¿Es un solo pago?',
            a: 'Sí. Pagas una vez y el acceso es de por vida. Sin suscripciones ni pagos recurrentes.'
          }, {
            q: '¿Sirve si no sé nada de skincare?',
            a: 'Perfectamente. El sistema empieza desde cero y te lleva paso a paso sin asumir conocimientos previos.'
          }, {
            q: '¿Los bonos están incluidos en el precio?',
            a: 'Sí. Los 3 bonos están incluidos en los 13,99€. No hay nada más que pagar.'
          }, {
            q: '¿En qué formato vienen los archivos?',
            a: 'PDF de alta calidad. Compatible con móvil, tablet, PC y para imprimir en A4.'
          }, {
            q: '¿Tiene garantía de devolución?',
            a: 'Sí. 14 días de garantía total. Si no estás satisfecha te devolvemos el 100% sin preguntas.'
          }].map((faq, index) => <motion.div key={index} {...fadeInUp} transition={{
            delay: index * 0.05,
            duration: 0.5
          }} className="bg-[#F9F5FC] rounded-lg p-6" data-id="element-239">
                <h3 className="font-bold text-[#5B2D8E] text-lg mb-2" data-id="element-240">
                  P: {faq.q}
                </h3>
                <p className="text-[#4A4A4A]" data-id="element-241">R: {faq.a}</p>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="py-12 md:py-20 px-4 bg-gradient-to-b from-[#F9F5FC] to-white" data-id="element-242">
        <div className="max-w-4xl mx-auto text-center" data-id="element-243">
          <motion.h2 {...fadeInUp} className="text-3xl md:text-5xl font-bold text-[#5B2D8E] mb-4" data-id="element-244">
            Tu piel no necesita más productos.
            <br data-id="element-245" />
            Necesita la verdad.
          </motion.h2>
          <motion.p {...fadeInUp} className="text-lg md:text-xl text-[#4A4A4A] mb-8" data-id="element-246">
            +2.800 mujeres en España ya cuidan su piel con criterio. Hoy es tu
            turno.
          </motion.p>
          <motion.div {...fadeInUp} data-id="element-247">
            <a href="#pricing" className="inline-block bg-[#C9A84C] hover:bg-[#b89840] text-white font-bold text-xl px-10 py-5 rounded-lg transition-colors shadow-lg mb-4" data-id="element-248">
              🚀 SÍ, QUIERO EL AUDITOR DE SKINCARE™
            </a>
            <p className="text-sm text-[#4A4A4A]" data-id="element-249">
              ⚡ Acceso inmediato · 🛡️ Garantía 14 días · 💳 Pago único desde
              13,99€
            </p>
          </motion.div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#5B2D8E] text-white py-8 px-4" data-id="element-250">
        <div className="max-w-6xl mx-auto text-center" data-id="element-251">
          <p className="font-bold text-lg mb-2" data-id="element-252">🧴 EL AUDITOR DE SKINCARE™</p>
          <p className="text-sm opacity-90 mb-4" data-id="element-253">
            Cosmética con criterio. Sin humo.
          </p>
          <p className="flex items-center justify-center gap-2 mb-4" data-id="element-254">
            <Mail className="w-4 h-4" data-id="element-255" />
            <a href="mailto:digipromarket3@gmail.com" className="hover:text-[#C9A84C] transition-colors" data-id="element-256">
              digipromarket3@gmail.com
            </a>
          </p>
          <div className="flex flex-wrap justify-center gap-4 text-sm mb-4" data-id="element-257">
            <a href="#" className="hover:text-[#C9A84C] transition-colors" data-id="element-258">
              Política de Privacidad
            </a>
            <span data-id="element-259">·</span>
            <a href="#" className="hover:text-[#C9A84C] transition-colors" data-id="element-260">
              Términos y Condiciones
            </a>
            <span data-id="element-261">·</span>
            <a href="#" className="hover:text-[#C9A84C] transition-colors" data-id="element-262">
              Política de Devoluciones
            </a>
          </div>
          <p className="text-sm opacity-75" data-id="element-263">
            © EL AUDITOR DE SKINCARE™ 2026 — Todos los derechos reservados.
          </p>
        </div>
      </footer>
    </div>;
}